import { createGlobalStyle } from 'styled-components';

const FontStyleIcon = createGlobalStyle`
  @font-face {
    font-family: 'icomoon';
    src: url('/static/fonts/icomoon.eot?u2rthv');
    src: url('/static/fonts/icomoon.eot?u2rthv#iefix') format('embedded-opentype'),
    url('/static/fonts/icomoon.ttf?u2rthv') format('truetype'),
    url('/static/fonts/icomoon.woff?u2rthv') format('woff'),
    url('/static/fonts/icomoon.svg?u2rthv#icomoon') format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  [class^="icon-"], [class*=" icon-"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: 'icomoon' !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .icon-Frame-2608160 .path1:before {
    content: "\\e90f";
    color: rgb(255, 255, 255);
  }

  .icon-Frame-2608160 .path2:before {
    content: "\\e910";
    margin-left: -1em;
    color: rgb(0, 184, 107);
  }

  .icon-Frame-2608160 .path3:before {
    content: "\\e911";
    margin-left: -1em;
    color: rgb(0, 184, 107);
  }

  .icon-camera .path1:before {
    content: "\\e913";
    color: rgb(255, 255, 255);
  }

  .icon-camera .path2:before {
    content: "\\e91b";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-camera .path3:before {
    content: "\\e91c";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-car-door-1 .path1:before {
    content: "\\e914";
    color: rgb(25, 191, 122);
  }

  .icon-car-door-1 .path2:before {
    content: "\\e922";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }

  .icon-car-door-1 .path3:before {
    content: "\\e923";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-cooler-1 .path1:before {
    content: "\\e915";
    color: rgb(255, 255, 255);
  }

  .icon-cooler-1 .path2:before {
    content: "\\e924";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }

  .icon-cooler-1 .path3:before {
    content: "\\e925";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-engine-2-1 .path1:before {
    content: "\\e916";
    color: rgb(255, 255, 255);
  }

  .icon-engine-2-1 .path2:before {
    content: "\\e926";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-engine-3-1 .path1:before {
    content: "\\e917";
    color: rgb(255, 255, 255);
  }

  .icon-engine-3-1 .path2:before {
    content: "\\e927";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-Frame-2608155 .path1:before {
    content: "\\e918";
    color: rgb(255, 255, 255);
  }

  .icon-Frame-2608155 .path2:before {
    content: "\\e928";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-Frame-2608155 .path3:before {
    content: "\\e929";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-Frame-2608157 .path1:before {
    content: "\\e919";
    color: rgb(25, 191, 122);
  }

  .icon-Frame-2608157 .path2:before {
    content: "\\e92a";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }

  .icon-Frame-2608157 .path3:before {
    content: "\\e92b";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-Frame-2608157 .path4:before {
    content: "\\e92c";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-Frame-2608157 .path5:before {
    content: "\\e92d";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-Frame-2608157 .path6:before {
    content: "\\e92e";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-Group-33827 .path1:before {
    content: "\\e91a";
    color: rgb(255, 255, 255);
  }

  .icon-Group-33827 .path2:before {
    content: "\\e92f";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }

  .icon-Group-33827 .path3:before {
    content: "\\e930";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }

  .icon-Group-33827 .path4:before {
    content: "\\e931";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }

  .icon-Group-33827 .path5:before {
    content: "\\e932";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-Group-33827 .path6:before {
    content: "\\e933";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-Group-33827 .path7:before {
    content: "\\e934";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-Group-33827 .path8:before {
    content: "\\e935";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-Group-33827 .path9:before {
    content: "\\e936";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-Group-33827 .path10:before {
    content: "\\e937";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-Group-33827 .path11:before {
    content: "\\e938";
    margin-left: -1em;
    color: rgb(25, 191, 122);
  }

  .icon-Checkbox-and-Radio-Buttons1:before {
    content: "\\e904";
    color: #b2c2d6;
  }

  .icon-Checkbox-and-Radio-Buttons .path1:before {
    content: "\\e900";
    color: rgb(6, 199, 141);
  }

  .icon-Checkbox-and-Radio-Buttons .path2:before {
    content: "\\e901";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }

  .icon-Checkbox-and-Radio-Buttons .path3:before {
    content: "\\e902";
    margin-left: -1em;
    color: rgb(6, 199, 141);
  }

  .icon-warning-1:before {
    content: "\\e93d";
    color: #ff4869;
  }

  .icon-Check:before {
    content: "\\e93a";
    color: #fff;
  }

  .icon-Close-Outline:before {
    content: "\\e954";
    color: #6783a0;
  }

  .icon-u_star:before {
    content: "\\e905";
    color: #00b86b;
  }

  .icon-Right-Icon:before {
    content: "\\e903";
    color: #fff;
  }

  .icon-Big-Arrows:before {
    content: "\\e906";
    color: #fff;
  }

  .icon-gallery-add:before {
    content: "\\e907";
    color: #fff;
  }

  .icon-Left-icon34:before {
    content: "\\e908";
    color: #fff;
  }

  .icon-Left-icon:before {
    content: "\\e909";
    color: #fff;
  }

  .icon-u_image-upload:before {
    content: "\\e90a";
    color: #00b86b;
  }

  .icon-u_trash-alt:before {
    content: "\\e90b";
    color: #fff;
  }

  .icon-u_camera-plus:before {
    content: "\\e90c";
  }

  .icon-tick-circle:before {
    content: "\\e90d";
  }

  .icon-close-circle:before {
    content: "\\e90e";
  }

  .icon-chassis-1 .path1:before {
    content: "\\e912";
    color: rgb(255, 255, 255);
  }

  .icon-chassis-1 .path2:before {
    content: "\\e939";
    margin-left: -1em;
    color: rgb(255, 255, 255);
  }

  .icon-chassis-1 .path3:before {
    content: "\\e93b";
    margin-left: -1em;
    color: rgb(0, 0, 0);
  }

  .icon-chassis-1 .path4:before {
    content: "\\e93c";
    margin-left: -1em;
    color: rgb(0, 0, 0);
  }

  .icon-Icons:before {
    content: "\\e91d";
    color: #fff;
  }

  .icon-fi_calendar:before {
    content: "\\e91e";
    color: #aec1da;
  }

  .icon-clock:before {
    content: "\\e91f";
    color: #aec1da;
  }

  .icon-profile:before {
    content: "\\e920";
    color: #fff;
  }

  .icon-fi_check-circle:before {
    content: "\\e921";
    color: #00b86b;
  }
`;
export default FontStyleIcon;
